import React from 'react'

// utils
import { createRequestItemCards } from './ItemsForRequest.collection.utils'

// graphql
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

export default function ItemsForRequest({ requestId }) {

    let cards = []

    const { data } = useQuery(GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS, {
        variables: { id: requestId }
    })

    if(data && data.equipmentRequest) {
        cards = [...createRequestItemCards(data.equipmentRequest)]
    }


    return (<div className='requests-by-status'>

        {
            cards.map(card => {
                return (<FourSectionCardListItem 
                    mainTitle={card.name}
                    subTitle={`SKU# ${card.sku}`}
                    leftData={[`Requested: ${card.requestedQty}`]}
                    rightData={`Shipped: ${card.shippedQty}`}
                />)
            })
        }
    </div>)
}